module.exports = __webpack_public_path__ + "img/circle.7867e80f.svg";